import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';

import { useAuth } from '../../../app/providers/useAuth';
import type { EveningReminderSettings, EveningReminderSettingsUpdate } from '../../../api/types';
import { fetchEveningReminderSettings, updateEveningReminderSettings } from '../api/settingsApi';

// PARA-136 — React Query hook для GET/PATCH настроек вечернего напоминания.

const QUERY_KEY = 'evening-reminder-settings';

export interface UseEveningReminderSettingsResult {
  settings: UseQueryResult<EveningReminderSettings>;
  updateSettings: UseMutationResult<EveningReminderSettings, Error, EveningReminderSettingsUpdate>;
  isLoading: boolean;
  isSaving: boolean;
}

export function useEveningReminderSettings(): UseEveningReminderSettingsResult {
  const { user } = useAuth();

  const settings = useQuery<EveningReminderSettings>({
    queryKey: [QUERY_KEY, user?.id],
    queryFn: fetchEveningReminderSettings,
    enabled: user !== null,
  });

  const updateSettings = useMutation<EveningReminderSettings, Error, EveningReminderSettingsUpdate>(
    {
      mutationFn: updateEveningReminderSettings,
      onSuccess: () => {
        void settings.refetch();
      },
    },
  );

  return {
    settings,
    updateSettings,
    isLoading: settings.isLoading,
    isSaving: updateSettings.isPending,
  };
}
